module.exports = __webpack_public_path__ + "media/f06.d25a25f3.mp4";